import { render, staticRenderFns } from "./parcelcode.vue?vue&type=template&id=48431856&"
import script from "./parcelcode.vue?vue&type=script&lang=js&"
export * from "./parcelcode.vue?vue&type=script&lang=js&"
import style0 from "./parcelcode.vue?vue&type=style&index=0&id=48431856&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports